import React, { useState } from "react";
import Box from "@mui/material/Box";
import { gr } from "src/design-system/tokens";
import GrTextField from "src/design-system/components/GrTextField";
import GrButton from "src/design-system/components/GrButton";

export default function LinkPopup({ handleAddLink }) {
  const [inputs, setInputs] = useState({ display_text: "", link_address: "" });

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleAddLink(inputs);
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: gr.space[4],
        pt: gr.space[2],
      }}
    >
      <GrTextField
        id="link-display-text"
        label="Text to Display"
        required
        name="display_text"
        value={inputs.display_text}
        onChange={handleChange}
      />
      <GrTextField
        type="url"
        id="link-address"
        label="Link Address"
        required
        name="link_address"
        value={inputs.link_address}
        onChange={handleChange}
      />
      {/* Dialog standard: action bottom-right, not full width. */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: gr.space[2] }}>
        <GrButton type="submit">Insert</GrButton>
      </Box>
    </Box>
  );
}
